import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';

import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi.ts';
import { HealthcareFacility } from '../HealthcareFacility.ts';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute.tsx';

export function useGetHealthcareFacilityById() {
    const id = useIdFromRoute();

    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.healthcareFacility, id],
        queryFn: async () => {
            const result = await HealthcareFacilitiesApi.getHealthcareFacilitiesById(id!);
            return result ? new HealthcareFacility(result) : result;
        },
        enabled: !!id && id !== '0',
    });
}
